.face {
  display: inline-grid;
  place-items: center;
  flex: none;
  aspect-ratio: 180 / 314;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--pill-bg);
}

img.face {
  border: 0;
  border-radius: 0;
  background: none;
  object-fit: contain;
}

.blank {
  padding: 6px;
  color: var(--muted);
  font-size: 12px;
  line-height: 1.3;
  text-align: center;
  overflow-wrap: anywhere;
}

.xs {
  width: 40px;
  border-radius: 6px;
}

.sm {
  width: 64px;
  border-radius: 8px;
}

.md {
  width: 112px;
}

.lg {
  width: 160px;
  border-radius: 14px;
}
